import React from "react";
import { Box, Typography } from "@mui/material";

// Import all activity components
import MCMAQuestion from "./MCMAQuestion";
import Match from "./Match";
import MarkupActivity from "./Markup";
import ReArrangeActivity from "./ReArrange";
import RankingActivity from "./Ranking";
import MFBActivity from "./MFB";
import IraabActivity from "./Iraab";

const ActivityRenderer = ({
  activity,
  index,
  total,
  submitted,
  answers,
  preview = false,
  ...rest
}) => {
  if (!activity) return null;

  return (
    <Box>
      <Box sx={{ marginBottom: "20px" }}>
        <Typography
          variant="casting"
          gutterBottom
          sx={{
            fontWeight: "bold",
            fontSize: "0.75rem",
            fontStyle: "italic",
          }}
        >
          Question
        </Typography>

        {typeof index === "number" && typeof total === "number" && (
          <Typography
            variant="body1"
            gutterBottom
            color="primary.main"
            fontWeight="bold"
            fontFamily="Merriweather, serif"
          >
            {index + 1}/{total}
          </Typography>
        )}

        {/* Title Block */}
        <Box
          sx={{
            fontSize: "0.95rem",
            "& *": {
              fontSize: "0.95rem !important",
            },
          }}
          dangerouslySetInnerHTML={{
            __html: activity?.Title || "",
          }}
        />
      </Box>
      {activity.Type === "MCMA" && (
        <MCMAQuestion
          currentActivity={activity}
          submitted={submitted}
          answers={answers}
          preview={preview}
          {...rest}
        />
      )}

      {activity.Type === "Match" && (
        <Match
          currentActivity={activity}
          submitted={submitted}
          preview={preview}
          {...rest}
        />
      )}

      {activity.Type === "Markup" && (
        <MarkupActivity
          currentActivity={activity}
          submitted={submitted}
          preview={preview}
          {...rest}
        />
      )}

      {activity.Type === "ReArrange" && (
        <ReArrangeActivity
          currentActivity={activity}
          submitted={submitted}
          preview={preview}
          {...rest}
        />
      )}

      {activity.Type === "Ranking" && (
        <RankingActivity
          currentActivity={activity}
          submitted={submitted}
          preview={preview}
          {...rest}
        />
      )}

      {activity.Type === "MFB" && (
        <MFBActivity
          currentActivity={activity}
          submitted={submitted}
          preview={preview}
          shuffledMfbOptions={rest.shuffledMfbOptions} // ★ FIX
          mfbSelections={rest.mfbSelections}
          handleOptionChange={rest.handleOptionChange}
        />
      )}

      {activity.Type === "Iraab" && (
        <IraabActivity
          currentActivity={activity}
          submitted={submitted}
          preview={preview}
          {...rest}
        />
      )}

      {/* In case an unknown type appears */}
      {![
        "MCMA",
        "Match",
        "Markup",
        "ReArrange",
        "Ranking",
        "MFB",
        "Iraab",
      ].includes(activity.Type) && (
        <Typography color="error">
          Unknown activity type: {activity.Type}
        </Typography>
      )}
    </Box>
  );
};

export default ActivityRenderer;
